import { Alert, IconButton, Typography } from '@mui/material'

import useTranslations from '../../../i18n/useTranslations'

import styles from './styles'
import { ReactComponent as X } from '../../../assets/icons/x.svg'

const ImportantAlertView = ({ onClose }) => {
  const t = useTranslations()

  return (
    <Alert
      severity="warning"
      sx={{ ...styles.alert, ...styles.alertWarning }}
      action={
        <IconButton
          aria-label="close"
          color="inherit"
          size="small"
          onClick={() => {
            onClose()
          }}
        >
          <X />
        </IconButton>
      }
    >
      <Typography component="p" variant="body2">
        <strong>{t('noun:important')}</strong>
      </Typography>
      <Typography component="p" variant="body2">
        {process.env.REACT_APP_SHOW_IMPORTANT_ALERT}
      </Typography>
    </Alert>
  )
}

export default ImportantAlertView
